import { Box, Typography } from '@mui/material'

import { DateTime } from 'luxon'

import logo from '@assets/logo_dark.svg'

import { LAYER_DATA } from './LayerSelector'

export default function ConnectivityPDF({
  property,
  layer,
  rows,
  legend,
  components,
  fixedHeaderContent,
  itemContent,
}) {
  const { Scroller, Table, TableHead, TableRow, TableBody } = components

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        left: '-99999px',
      }}
    >
      <Box
        id="printable_canvas"
        display="flex"
        flexDirection="column"
        position="relative"
        sx={{ height: 1, width: 1, minHeight: 650 }}
      >
        <Box
          display="flex"
          gap={4}
          alignItems="center"
          justifyContent="space-between"
          width={1}
        >
          <Box display="flex" gap={4} alignItems="center">
            <img
              src={logo}
              alt="Rest Potal"
              style={{ height: 40, margin: '30px 0px 30px 20px' }}
            />
            <Box display="flex" flexDirection="column">
              <Typography noWrap variant="h6">
                {property?.name}
              </Typography>
              <Typography noWrap variant="caption" color="grey">
                {LAYER_DATA[layer].label},{' '}
                {DateTime.now().toLocaleString(DateTime.DATETIME_MED)}
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            sx={{ gap: 1, overflow: 'hidden', maxHeight: 80, mr: 2 }}
          >
            {Object.entries(legend[layer]).map(([key, { color }]) => (
              <Box key={key} display="flex" alignItems="center" gap={0.5}>
                <Box width={10} height={10} sx={{ backgroundColor: color }} />
                <Typography noWrap variant="caption">
                  {key}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        <Scroller>
          <Table size="small">
            <TableHead>{fixedHeaderContent()}</TableHead>
            <TableBody>
              {rows?.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <TableRow key={index}>{itemContent(index, item)}</TableRow>
              ))}
            </TableBody>
          </Table>
        </Scroller>
      </Box>
    </div>
  )
}
